import { render } from "./YoutubePlayer.vue?vue&type=template&id=7b4cdbf2"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__